import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonDirective } from './buttons.directive';

@NgModule({
  imports: [CommonModule, ButtonDirective],
  declarations:[],
  exports:[ButtonDirective]

})
export class ButtonsModule {}
